import { Flex, Paper, Title, Text, Button } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { formatCurrencyPaymentPeriod } from '@shared/helpers';
import { VacancyPoint } from '../vacancyPoint';
import { VacancyItemPoint } from '../vacancyItemPoint';

type VacancyMainInfoCardProps = {
  name: string;
  companyName: string;
  cityNames: string;
  requiredCandidatesCount: number;
  activitySpheres: string;
  handleEdit: () => void;
  scheduleWorks: string;
  employmentTypes: string;
  skills: string;
  salaryFrom: number;
  salaryTo: number;
  currencyValue: string;
  paymentPeriod: string;
  mandatoryRequirements: string;
  additionalRequirements: string;
  responsibilities: string;
  interviewFinalMessage: string;
};

export const VacancyMainInfoCard = ({
  name,
  companyName,
  cityNames,
  requiredCandidatesCount,
  activitySpheres,
  handleEdit,
  scheduleWorks,
  employmentTypes,
  skills,
  salaryFrom,
  salaryTo,
  currencyValue,
  paymentPeriod,
  mandatoryRequirements,
  additionalRequirements,
  responsibilities,
  interviewFinalMessage,
}: VacancyMainInfoCardProps) => {
  const formattedPeriod = formatCurrencyPaymentPeriod(
    currencyValue,
    paymentPeriod
  );

  return (
    <Paper p={24} radius={16} bg='primary.0' w='100%' maw={1070}>
      <Flex gap={24} direction='column'>
        <Flex w='100%' justify='space-between' wrap='wrap'>
          <Title order={4}>Основная информация</Title>

          <Button
            variant='subtle'
            size='md'
            leftSection={<IconPencil size={20} />}
            onClick={handleEdit}
          >
            Редактировать
          </Button>
        </Flex>

        <Flex gap={24} w='100%' direction='column'>
          <Flex direction='column' gap={8}>
            <Text c='tertiary.7' size='sm'>
              Компания
            </Text>
            <Text c='primary.7'>{companyName}</Text>
          </Flex>

          {activitySpheres && (
            <Flex direction='column' gap={8}>
              <Text c='tertiary.7' size='sm'>
                Профессия
              </Text>
              <Text c='primary.7'>{activitySpheres}</Text>
            </Flex>
          )}

          <Flex direction='column' gap={8}>
            <Text c='tertiary.7' size='sm'>
              Название вакансии
            </Text>
            <Text c='primary.7'>{name}</Text>
          </Flex>

          {responsibilities && (
            <VacancyItemPoint
              subTitle='Обязанности по вакансии'
              points={responsibilities}
            />
          )}

          <Flex direction='column' gap={8}>
            <Text c='tertiary.7' size='sm'>
              Количество вакантных мест
            </Text>
            <Text c='primary.7'>{requiredCandidatesCount}</Text>
          </Flex>

          <Flex direction='column' gap={8}>
            <Text c='tertiary.7' size='sm'>
              Город
            </Text>
            <Text c='primary.7'>{cityNames}</Text>
          </Flex>

          <VacancyPoint title='Тип занятости' value={employmentTypes} />

          <VacancyPoint title='График работы' value={scheduleWorks} />

          <VacancyPoint
            title='Уровень дохода'
            value={`${salaryFrom} - ${salaryTo} ${formattedPeriod}`.trim()}
          />

          {mandatoryRequirements && (
            <VacancyItemPoint
              subTitle='Обязательные требования к кандидату'
              points={mandatoryRequirements}
            />
          )}

          {additionalRequirements && (
            <VacancyItemPoint
              subTitle='Дополнительные требования к кандидату'
              points={additionalRequirements}
            />
          )}

          <VacancyPoint title='Ключевые навыки' value={skills} />

          <VacancyPoint
            title='Сообщение для заинтересовавшихся'
            value={interviewFinalMessage}
          />
        </Flex>
      </Flex>
    </Paper>
  );
};
